import React from "react";
import Hotel_ActiveUsersData_card from "./hotel_activeUsersData_card/Hotel_ActiveUsersData_card";

function Hotel_ActiveUsersData() {
  return (
    <>
      <section className="ActiveUsersData">
        <div className="row">
          <div className="col-lg-12 col-sm-6 col-12">
            <Hotel_ActiveUsersData_card />
          </div>

          <div className="col-lg-12 col-sm-6 col-12">
            <Hotel_ActiveUsersData_card />
          </div>

          <div className="col-lg-12  col-sm-6 col-12">
            <Hotel_ActiveUsersData_card />
          </div>

          <div className=" col-lg-12 col-sm-6 col-12">
            <Hotel_ActiveUsersData_card />
          </div>
        </div>
      </section>
    </>
  );
}

export default Hotel_ActiveUsersData;
